import { gql, useQuery } from '@apollo/client';

export const GET_CONSULTANT_NUMBER_BY_ID = gql`
  query getConsultantNumberById($consultantNumberId: ObjectId!) {
    getConsultantNumberById(consultantNumberId: $consultantNumberId) {
      _id
      consultantNumber
      details
      datevClientNumbers {
        _id
      }
    }
  }
`;

export const useGetConsultantNumberById = (id?: string) => {
  const { data, loading } = useQuery(GET_CONSULTANT_NUMBER_BY_ID, {
    variables: {
      consultantNumberId: id,
    },
    skip: !id,
    fetchPolicy: 'network-only',
  });

  return { loading, datevNumber: data?.getConsultantNumberById || {} };
};
